// extracted by css-extract-rspack-plugin
export default {"wrapper":"cJy7_","input":"qjJao","section":"PiDKx","label":"muVia","description":"rIblO","error":"LKPiN","required":"Va6FB"};